<template>
    <ideo-filter :name="name" :label="label" :display="filterDisplay" @clear="resetFilter">
        <ideo-form-group :label="$t('[[[Strefy]]]')">
            <ZonesPicker
                v-model="zonesPublicIdsValues"
                :name="`zonesPublicIds`"
                :refresh="true"
                :multiple="true"
                :without-users-and-default-zones="true"
                ref="rowCodeRangeZonesPicker"
            />
        </ideo-form-group>
        <div class="date-range d-flex flex-column flex-md-row gap-2">
            <ideo-form-group :label="$t('[[[Od]]]')" :nospace="true">
                <ideo-form-input :name="name" v-model="fromValue" type="number" v-focus></ideo-form-input>
            </ideo-form-group>
            <ideo-form-group :label="$t('[[[Do]]]')" :nospace="true">
                <ideo-form-input :name="name" v-model="toValue" type="number" :min="fromValue" v-focus></ideo-form-input>
            </ideo-form-group>
        </div>
        <ideo-input-group class="mt-3">
            <ideo-form-checkbox v-model="onlyWithCurrentZonesAndRowCodeRangeValue">{{ $t('[[[Dokumenty zawierające pozycje tylko z podanych regałów]]]') }}</ideo-form-checkbox>
        </ideo-input-group>
    </ideo-filter>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import ZonesPicker from "../pickers/zones/ZonesPicker.vue";

interface Props
{
    from?: number
    to?: number
    label?: string
    name: string
    zonesPublicIds?: string[]
    onlyWithCurrentZonesAndRowCodeRange: boolean
}

const props = withDefaults(defineProps<Props>(), {
    from: null,
    to: null,
    label: '',
    name: '',
    zonesPublicIds: null,
    onlyWithCurrentZonesAndRowCodeRange: false
});

defineOptions({
    name: 'row-code-range-filter',
    inheritAttrs: false,
});

const emit = defineEmits<{
    (e: 'update:from', value: number): void,
    (e: 'update:to', value: number): void,
    (e: 'update:zonesPublicIds', value: string[]): void,
    (e: 'update:onlyWithCurrentZonesAndRowCodeRange', value: boolean): void,
}>();

const rowCodeRangeZonesPicker = ref<typeof ZonesPicker>(null);

const fromValue = computed({
    get()
    {
        return props.from;
    },
    set(value: number)
    {
        emit('update:from', value);
    }
});

const toValue = computed({
    get()
    {
        return props.to;
    },
    set(value: number)
    {
        emit('update:to', value);
    }
});

const zonesPublicIdsValues = computed({
    get()
    {
        return props.zonesPublicIds;
    },
    set(value: string[])
    {
        emit('update:zonesPublicIds', value);
    }
});

const filterDisplay = computed<string>(() =>
{
    if (!props.from && !props.to)
        return '';

    return (props.from ?? "N/A") + " - " + (props.to ?? "N/A");
});

const onlyWithCurrentZonesAndRowCodeRangeValue = computed({
    get()
    {
        return props.onlyWithCurrentZonesAndRowCodeRange;
    },
    set(value: boolean)
    {
        emit('update:onlyWithCurrentZonesAndRowCodeRange', value);
    }
});

const resetFilter = (): void =>
{
    fromValue.value = null;
    toValue.value = null;
    zonesPublicIdsValues.value = [];
    onlyWithCurrentZonesAndRowCodeRangeValue.value = false;
};
</script>

